module.exports = __webpack_public_path__ + "static/media/PoiTemplate.dca2bc1a.csv";